import { Button } from "@mui/material";
import styled from "styled-components";
import { colors } from "./Style";

export const PrimaryButton = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
`;

export const CreateButton = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  color: #fff;
  border: 1px solid ${colors.lightBlue};
`;

export const CreateButtonLoading = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  color: ${colors.publicisBlue};
  background: white;
  &:hover {
    color: ${colors.publicisBlue};
    background: white;
  }
`;

export const PrimaryLoadingButton = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
`;

export const CancelButton = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  border-color: #bdbdbd;
  color: #bdbdbd;

  &:hover {
    border: 1px solid #bdbdbd;
  }
`;

export const CancelLoadingButton = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  border-color: #bdbdbd;
  color: #bdbdbd;

  &:hover {
    border: 1px solid #bdbdbd;
  }
`;

export const ErrorButton = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  border-color: ${colors.error};
  color: ${colors.error};

  &:hover {
    border: 1px solid ${colors.error};
  }
`;

export const Accept = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  background: ${colors.green};

  &:hover {
    background: ${colors.green};
  }
`;

export const Reject = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  color: #fff;
  padding: 8px 22px;
  background: ${colors.error};

  &:hover {
    background: ${colors.error};
  }
`;

export const Pending = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  background: ${colors.yellow};

  &:hover {
    background: ${colors.yellow};
  }
`;

export const AcceptUpload = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  background: ${colors.blue};

  &:hover {
    background: ${colors.blue};
  }
`;
